// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from '../../components/CRUD/AddEntity';

const AddOrganisationBanks = () => {
  // Configuration for Organisation Bank inputs
  const inputs = [
    {
      name: 'account_name',
      labelKey: 'AccountName',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'account_number',
      labelKey: 'AccountNumber',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'iban',
      labelKey: 'IBAN',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'branch_name',
      labelKey: 'BranchName',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'branch_address',
      labelKey: 'BranchAddress',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'beneficiary_email',
      labelKey: 'BeneficiaryEmail',
      type: 'email',
      required: true,
      defaultValue: ''
    },
    {
      name: 'beneficiary_mobile',
      labelKey: 'BeneficiaryMobile',
      type: 'text',
      required: true,
      defaultValue: ''
    }
  ];

  // Dropdowns configuration
  const dropdowns = [
    {
      name: 'organisation_id',
      labelKey: 'Organisation',
      required: true,
      defaultValue: '',
      apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
      apiMethod: 'GET',
      dataPath: 'data.data', // Axios wraps response in data, then API has data property
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_name',
        labelKeyAr: 'ar_name'
      }
    },
    {
      name: 'bank_id',
      labelKey: 'Bank',
      required: true,
      defaultValue: '',
      apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/banks`,
      apiMethod: 'GET',
      dataPath: 'data.data.banks', // Axios wraps in data, API has data.banks
      optionConfig: {
        valueKey: 'id',
        labelKey: 'bank_name_en',
        labelKeyAr: 'bank_name_ar'
      }
    },
    {
      name: 'financial_account_id',
      labelKey: 'FinancialAccount',
      required: true,
      defaultValue: '',
      dependsOn: 'organisation_id',
      apiUrl: (formValues) =>
        `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts/org/${formValues.organisation_id}`,
      apiMethod: 'GET',
      dataPath: 'data.data.financialAccounts', // Axios wraps in data, API has data.financialAccounts
      optionConfig: {
        valueKey: 'id',
        labelKey: 'name',
        labelKeyAr: 'name'
      }
    }
  ];

  // Build the payload for organisation bank submission
  const buildSubmitPayload = (formValues) => {
    return {
      organisation_id: formValues.organisation_id,
      bank_id: formValues.bank_id,
      account_name: formValues.account_name.trim(),
      account_number: formValues.account_number.trim(),
      iban: formValues.iban.trim(),
      branch_name: formValues.branch_name.trim(),
      branch_address: formValues.branch_address.trim(),
      beneficiary_email: formValues.beneficiary_email.trim(),
      beneficiary_mobile: formValues.beneficiary_mobile.trim(),
      financial_account_id: formValues.financial_account_id
    };
  };

  return (
    <AddEntity
      pageTitle="AddNewOrganisationBank"
      inputs={inputs}
      dropdowns={dropdowns}
      submitApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/organisation-banks`}
      buildSubmitPayload={buildSubmitPayload}
      backUrl="/settlements/OrganisationBanks/"
      successMessage="OrganisationBankAddedSuccessfully"
      addButtonLabel="Save"
      subsystemName="OrganisationBanks"
    />
  );
};

export default AddOrganisationBanks;
